import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { DateTimeService } from '../../../core/services/date-time.service';

@Component({
    selector: 'app-date-period-time',
    templateUrl: './date-period-time.component.html',
    styles: [``],
    standalone: false
})
export class PeriodDateTimePicker implements OnInit {

  //#region properties

  @Input() config: PeriodDateTimeConfig;

  @Output('startDateTime') output_startDateTimeValue = new EventEmitter<any>();
  @Output('endDateTime') output_endDateTimeValue = new EventEmitter<any>();

  startDate;
  endDate;
  startTime;
  endTime;

  startDateTime;
  endDateTime;

  maxStartTime;
  minEndTime;

  isShowError: boolean = false;

  //#endregion

  constructor() { }

  ngOnInit() {
    this.initValues();
    if (this.config?.startDateTimeValue || this.config?.endDateTimeValue)
      this.separateDateAndTime();
  }

  initValues() {

    this.startDate = "today";
    this.startTime = "now";

  }

  setMinMaxTime() {

    //hide error
    if (this.startTime && this.endTime)
      this.isShowError = false;

    if (this.startDate == String(this.endDate)) {

      this.minEndTime = this.startTime;
      this.maxStartTime = this.endTime;

      //check error
      if (this.startTime > this.endTime) {
        this.isShowError = true;
        this.startTime = "";
        this.endTime = "";
      }

    }
    else {
      this.minEndTime = "";
      this.maxStartTime = "";
    }


  }

  separateDateAndTime() {

    // get DateTime Start
    [this.startDate, this.startTime] = DateTimeService.separateDateTimeUTC(
      this.config?.startDateTimeValue
    );

    // get DateTime End
    [this.endDate, this.endTime] = DateTimeService.separateDateTimeUTC(
      this.config?.endDateTimeValue
    );

  }

  combineDateAndTime() {


    //start dateTime
    if (this.startDate && this.startTime)
      this.startDateTime = DateTimeService.combineDateTimeToUTC(this.startDate?.toString().toUTC(), this.startTime);
    else
      this.startDateTime = null;

    //end dateTime
    if (this.endDate && this.endTime)
      this.endDateTime = DateTimeService.combineDateTimeToUTC(this.endDate?.toString().toUTC(), this.endTime);
    else
      this.endDateTime = null;

    this.emitStartDateTime();
    this.emitEndDateTime();


  }

  emitStartDateTime() {
    this.output_startDateTimeValue.emit(this.startDateTime);
  }

  emitEndDateTime() {
    this.output_endDateTimeValue.emit(this.endDateTime);
  }

}


export interface PeriodDateTimeConfig {

  form?: FormGroup;
  formGroupName?: string;

  startDateLabel?: string;
  endDateLabel?: string;
  startTimeLabel?: string;
  endTimeLabel?: string;

  startDateControlName?: string;
  endDateControlName?: string;
  startTimeControlName?: string;
  endTimeControlName?: string;

  responsiveClassName?: string;

  startDateTimeValue?: any;
  endDateTimeValue?: any;

}
